// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"53baf025","869":"53baf025","886":"53baf025"}[chunkId] + ".chunk.css";
};